export const SOLICITACAO_SET_COMBOBOXCCM = "deca.SOLICITACAO_SET_COMBOBOXCCM";
export const SET_SOLICITACAO = "deca.SET_SOLICITACAO";
export const DESABILITADO_TIPOSOLICITACAO = "deca.DESABILITADO_TIPOSOLICITACAO";
export const SET_TIPOSOLICITACAO = "deca.SET_TIPOSOLICITACAO";
export const SET_CCMTIPOSOLICITACAO = "deca.SET_CCMTIPOSOLICITACAO";
export const SET_REDUCER_CCM_DISABLED = "solicitacao.SET_REDUCER_CCM_DISABLED";
export const RESET_FORM = "deca.RESET_FORM";
export const SOLICITACAO_SET_CPFCNPJ = "deca.SOLICITACAO_SET_CPFCNPJ";
export const SET_TIPOSOLICITACAO_ATUAL = "deca.SET_TIPOSOLICITACAO_ATUAL";
export const SET_DESCRICAO_SOLICITACAO = "deca.SET_DESCRICAO_SOLICITACAO";
export const SET_CCM = "deca.SET_CCM";
